
import { ServiceCategory } from '@/types/serviceTypes';

export const landscapeDesignCategory: ServiceCategory = {
  id: 'landscape-design',
  name: 'Landscape Design',
  icon: 'design',
  services: [
    {
      id: 'plant-design',
      title: 'Plant Design',
      description: 'Create stunning visual displays with thoughtfully selected plants that complement your property and provide year-round interest.',
      features: [
        'Custom plant selection',
        'Four-season interest planning',
        'Native plant options',
        'Color and texture coordination',
        'Low-maintenance designs'
      ],
      image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'landscape-design',
      title: 'Landscape Design',
      description: 'Comprehensive landscape planning services that transform your outdoor space into a beautiful, functional extension of your home.',
      features: [
        '3D visualization',
        'Master plan development',
        'Sustainable designs',
        'Phased implementation options',
        'Expert consultation'
      ],
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop'
    }
  ]
};
